import { createSelector } from '@reduxjs/toolkit';
import { ProductItemModel } from '../posts/types';
import type { RootState } from '../store';

const selectState = (state: RootState): RootState['products'] => state.products;

export const selectProductById = createSelector(
    [
        (state: RootState) => state,
        (state: RootState) => selectState(state).records,
        (state: RootState, productId: string = ''): string => productId,
    ],
    (state, records, productId): ProductItemModel | undefined => records[productId],
);

export const selectProductsCollection = createSelector(
    [(state) => state, (state: RootState, namespace: string): string => namespace],
    (draft, namespace) => {
        const identifiers = draft.products.collections[namespace]?.identifiers ?? [];

        return {
            next: draft.products.collections[namespace]?.next,
            items: identifiers
                .map((id: string) => selectProductById(draft, id))
                .filter(Boolean) as ProductItemModel[],
        };
    },
);

export const selectProductsCollectionLoading = createSelector(
    [selectState, (state: RootState, namespace: string): string => namespace],
    (draft, category): boolean => draft.collections[category]?.isLoading ?? false,
);

export const selectProductsCollectionInitialized = createSelector(
    [selectState, (state: RootState, namespace: string): string => namespace],
    (draft, namespace): boolean => draft.collections[namespace]?.isInitialized ?? false,
);
